module.exports = __webpack_public_path__ + "static/media/edit.5f98d64e.svg";